<app-project-details></app-project-details>

<app-project-closure-report></app-project-closure-report>
